import {
  defaultPersonalityTraits_es,
  defaultPersonalityTraits_en,
  dpdBeluxPersonalityTraits_en,
  galaPersonalityTraits_en,
} from "./personality";

export default {
  default: {
    name: "GetBoarded",
    logo: "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/organization/gtbrdd-logo.png",
    colorSet: [
      "#008000",
      "#3BA0BE",
      "#6859B4",
      "#E4D033",
      "#EA7526",
      "#C6211B",
      "#F36677",
      "#B3B3B3",
    ],
    activeMarketplace: false,
    editorTabs: {
      about: {
        name: "about",
        active: true,
        routeName: "editor-about",
      },
      contact: {
        name: "contact",
        active: true,
        routeName: "editor-contact",
      },
      "career-history": {
        name: "careerHistory",
        active: true,
        routeName: "editor-career-history",
      },
      "educational-qualifications": {
        name: "educationalQualifications",
        active: true,
        routeName: "editor-educational-qualifications",
      },
      skills: {
        name: "skills",
        active: true,
        routeName: "editor-skills",
      },
      personality: {
        name: "personality",
        active: true,
        routeName: "editor-personality",
      },
      projects: {
        name: "projects",
        active: true,
        routeName: "editor-projects",
      },
    },
    personalityTraits: {
      en: defaultPersonalityTraits_en,
      de: defaultPersonalityTraits_en,
      fr: defaultPersonalityTraits_en,
      pt: defaultPersonalityTraits_en,
      es: defaultPersonalityTraits_es,
      nl: defaultPersonalityTraits_en,
      it: defaultPersonalityTraits_en,
    },
  },
  "dpd-belux": {
    name: "DPD",
    logo: "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/organization/dpd-logo.jpeg",
    colorSet: ["#C6211B", "#F36677", "#B3B3B3"],
    activeMarketplace: true,
    editorTabs: {
      about: {
        name: "about",
        active: true,
        routeName: "editor-about-custom",
      },
      contact: {
        name: "contact",
        active: true,
        routeName: "editor-contact-custom",
      },
      "career-history": {
        name: "careerHistory",
        active: true,
        routeName: "editor-career-history-custom",
      },
      "educational-qualifications": {
        name: "educationalQualifications",
        active: true,
        routeName: "editor-educational-qualifications-custom",
      },
      skills: {
        name: "skills",
        active: true,
        routeName: "editor-skills-custom",
      },
      personality: {
        name: "personality",
        active: true,
        routeName: "editor-personality-custom",
      },
      projects: {
        name: "projects",
        active: true,
        routeName: "editor-projects-custom",
      },
    },
    personalityTraits: {
      en: dpdBeluxPersonalityTraits_en,
      de: dpdBeluxPersonalityTraits_en,
      fr: dpdBeluxPersonalityTraits_en,
      pt: dpdBeluxPersonalityTraits_en,
      es: dpdBeluxPersonalityTraits_en,
      nl: dpdBeluxPersonalityTraits_en,
      it: dpdBeluxPersonalityTraits_en,
    },
  },
  "people-tree-group": {
    name: "People Tree Group",
    logo: "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/organization/peopletreegroup.png",
    colorSet: ["#C6211B", "#F36677", "#B3B3B3"],
    activeMarketplace: false,
    editorTabs: {
      about: {
        name: "about",
        active: true,
        routeName: "editor-about-custom",
      },
      contact: {
        name: "contact",
        active: false,
        routeName: "editor-contact-custom",
      },
      "career-history": {
        name: "careerHistory",
        active: true,
        routeName: "editor-career-history-custom",
      },
      "educational-qualifications": {
        name: "educationalQualifications",
        active: true,
        routeName: "editor-educational-qualifications-custom",
      },
      skills: {
        name: "skills",
        active: true,
        routeName: "editor-skills-custom",
      },
      personality: {
        name: "personality",
        active: false,
        routeName: "editor-personality-custom",
      },
      projects: {
        name: "projects",
        active: true,
        routeName: "editor-projects-custom",
      },
    },
    personalityTraits: {
      en: defaultPersonalityTraits_en,
      de: defaultPersonalityTraits_en,
      fr: defaultPersonalityTraits_en,
      pt: defaultPersonalityTraits_en,
      es: defaultPersonalityTraits_es,
      nl: defaultPersonalityTraits_en,
      it: defaultPersonalityTraits_en,
    },
  },
  gala: {
    name: "Gala Games",
    logo: "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/organization/gtbrdd-logo.png",
    colorSet: [
      "#008000",
      "#3BA0BE",
      "#6859B4",
      "#E4D033",
      "#EA7526",
      "#C6211B",
      "#F36677",
      "#B3B3B3",
    ],
    activeMarketplace: false,
    editorTabs: {
      about: {
        name: "about",
        active: true,
        routeName: "editor-about-org",
      },
      skills: {
        name: "skills",
        active: true,
        routeName: "editor-skills-org",
      },
      abilities: {
        name: "abilities",
        active: true,
        routeName: "editor-abilities-org",
      },
      contact: {
        name: "contact",
        active: true,
        routeName: "editor-contact-org",
      },
      "career-history": {
        name: "careerHistory",
        active: true,
        routeName: "editor-career-history-org",
      },
      "educational-qualifications": {
        name: "educationalQualifications",
        active: true,
        routeName: "editor-educational-qualifications-org",
      },
      projects: {
        name: "projects",
        active: true,
        routeName: "editor-projects-org",
      },
    },
    personalityTraits: {
      en: galaPersonalityTraits_en,
      de: galaPersonalityTraits_en,
      fr: galaPersonalityTraits_en,
      pt: galaPersonalityTraits_en,
      es: galaPersonalityTraits_en,
      nl: galaPersonalityTraits_en,
      it: galaPersonalityTraits_en,
    },
  },
};
